import React from 'react';
import { motion } from 'framer-motion';
import { Heart, Quote, Star, MapPin, BadgeCheck, Folder, Paperclip } from 'lucide-react';
const testimonials = [{
  in: 'PA',
  n: 'Pablo A.',
  l: 'Tucumán',
  t: 'Apliqué el Sistema Anti-ATS un lunes. El miércoles me llamaron de dos empresas distintas. Llevaba 3 meses en silencio.',
  tag: 'Tomo 2 · Sistema Anti-ATS'
}, {
  in: 'VL',
  n: 'Valeria L.',
  l: 'Rosario',
  t: 'El script de negociación salarial me dio el coraje que me faltaba. Pedí $200.000 más de lo que pensaba pedir y me los dieron.',
  tag: 'Protocolo Total · Negociación'
}, {
  in: 'DM',
  n: 'Diego M.',
  l: 'Córdoba',
  t: 'Usé la respuesta de brecha laboral cuando me preguntaron por mi año sin trabajar. El reclutador me dijo que era una de las mejores respuestas que había escuchado.',
  tag: 'Protocolo Total · Scripts'
}, {
  in: 'SC',
  n: 'Sofía C.',
  l: 'Buenos Aires',
  t: 'Las plantillas Pro cambiaron la percepción de los reclutadores. Por primera vez siento que mi CV parece de alguien de alto nivel.',
  tag: 'Bono 3 · Plantillas Pro'
}];
export function MoreTestimonials() {
  return <section className="py-16 bg-graphite border-y border-petroleum relative overflow-hidden" data-id="element-454">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[700px] h-[700px] bg-electric/5 blur-[120px] rounded-full pointer-events-none" data-id="element-455"></div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-456">
        {/* Framed Header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="relative max-w-3xl mx-auto mb-12" data-id="element-457">
          <div className="absolute -inset-1 bg-gradient-to-r from-electric via-yellow-300 to-electric rounded-3xl blur-xl opacity-30 animate-pulse" data-id="element-458"></div>
          <div className="relative bg-gradient-to-br from-graphite via-petroleum to-graphite border-2 border-electric rounded-3xl p-8 md:p-10 text-center overflow-hidden shadow-2xl shadow-electric/20" data-id="element-459">
            <div className="absolute inset-0 opacity-[0.08] pointer-events-none" style={{
            backgroundImage: 'linear-gradient(rgba(201,151,30,0.6) 1px, transparent 1px), linear-gradient(90deg, rgba(201,151,30,0.6) 1px, transparent 1px)',
            backgroundSize: '24px 24px'
          }} data-id="element-460"></div>
            <div className="absolute top-0 left-0 w-14 h-14 border-t-4 border-l-4 border-electric rounded-tl-3xl pointer-events-none" data-id="element-461"></div>
            <div className="absolute top-0 right-0 w-14 h-14 border-t-4 border-r-4 border-electric rounded-tr-3xl pointer-events-none" data-id="element-462"></div>
            <div className="absolute bottom-0 left-0 w-14 h-14 border-b-4 border-l-4 border-electric rounded-bl-3xl pointer-events-none" data-id="element-463"></div>
            <div className="absolute bottom-0 right-0 w-14 h-14 border-b-4 border-r-4 border-electric rounded-br-3xl pointer-events-none" data-id="element-464"></div>

            <div className="relative z-10" data-id="element-465">
              <div className="inline-flex items-center gap-2 bg-electric text-graphite px-4 py-1.5 rounded-full text-xs font-extrabold uppercase tracking-wider mb-5 shadow-lg shadow-electric/40" data-id="element-466">
                <Heart className="w-3.5 h-3.5 fill-graphite" data-id="element-467" />
                Historias reales
              </div>
              <h2 className="text-2xl md:text-4xl font-extrabold leading-tight" data-id="element-468">
                <span className="text-white" data-id="element-469">Más personas que </span>
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-electric via-yellow-300 to-electric drop-shadow-[0_0_12px_rgba(201,151,30,0.4)]" data-id="element-470">
                  ya lo tienen
                </span>
              </h2>
              <div className="mt-4 mx-auto h-px w-32 bg-gradient-to-r from-transparent via-electric to-transparent opacity-70" data-id="element-471"></div>

              {/* Aggregate trust row */}
              <div className="mt-5 flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-xs text-textsecondary" data-id="element-472">
                <div className="flex items-center gap-1.5" data-id="element-473">
                  <div className="flex" data-id="element-474">
                    {[...Array(5)].map((_, i) => <Star key={i} className="w-3.5 h-3.5 text-gold fill-gold" data-id="element-475" />)}
                  </div>
                  <span className="text-white font-bold" data-id="element-476">4.9/5</span>
                  <span data-id="element-477">· +1.200 lectores</span>
                </div>
                <span className="hidden md:inline w-1 h-1 rounded-full bg-textsecondary/40" data-id="element-478"></span>
                <div className="flex items-center gap-1.5" data-id="element-479">
                  <BadgeCheck className="w-3.5 h-3.5 text-electric" data-id="element-480" />
                  <span data-id="element-481">Compras verificadas</span>
                </div>
              </div>
            </div>
          </div>
        </motion.div>

        {/* Testimonial Cards */}
        <div className="grid md:grid-cols-2 gap-6 max-w-4xl mx-auto mt-8" data-id="element-482">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.08
        }} className="group relative bg-gradient-to-br from-cardbg to-graphite border border-white/10 rounded-2xl p-6 hover:border-electric/40 hover:shadow-[0_0_30px_rgba(201,151,30,0.15)] transition-all duration-300 mt-4" data-id="element-483">
              {/* Card Folder Tab */}
              <div className="absolute -top-3 left-4 z-20" data-id="element-484">
                <div className="bg-petroleum border border-electric/30 rounded-t-md px-2 py-0.5 flex items-center gap-1 transform -rotate-2" data-id="element-485">
                  <Folder className="w-2.5 h-2.5 text-textsecondary" data-id="element-486" />
                  <span className="text-[9px] font-mono font-bold uppercase tracking-widest text-textsecondary" data-id="element-487">
                    Recomendación #0{i + 4}
                  </span>
                </div>
              </div>

              {/* Paperclip */}
              <div className="absolute -top-2 -left-2 z-20 transform -rotate-45 text-textsecondary/40" data-id="element-488">
                <Paperclip className="w-5 h-5" data-id="element-489" />
              </div>

              {/* Stamp */}
              <div className="absolute bottom-4 right-4 z-20 pointer-events-none select-none" style={{
            transform: 'rotate(-10deg)'
          }} data-id="element-490">
                <div className="border-2 border-gold/40 rounded px-2 py-0.5" data-id="element-491">
                  <span className="text-gold/50 font-extrabold tracking-widest text-[10px] uppercase" data-id="element-492">
                    Contratado
                  </span>
                </div>
              </div>

              {/* Ruled-paper lines */}
              <div className="absolute inset-0 opacity-[0.02] pointer-events-none" style={{
            backgroundImage: 'repeating-linear-gradient(0deg, #ffffff 0px, #ffffff 1px, transparent 1px, transparent 24px)'
          }} data-id="element-493"></div>

              {/* Decorative quote mark */}
              <Quote className="absolute top-5 right-5 w-8 h-8 text-electric/15 group-hover:text-electric/30 transition-colors z-10" strokeWidth={2.5} data-id="element-494" />

              {/* Header: avatar + name + location */}
              <div className="flex items-center gap-3 mb-4 relative z-10" data-id="element-495">
                <div className="relative" data-id="element-496">
                  <div className="w-11 h-11 rounded-full bg-gradient-to-br from-electric to-yellow-500 text-graphite flex items-center justify-center font-extrabold text-sm shadow-lg shadow-electric/30" data-id="element-497">
                    {t.in}
                  </div>
                  <div className="absolute -bottom-0.5 -right-0.5 w-4 h-4 rounded-full bg-graphite flex items-center justify-center" data-id="element-498">
                    <BadgeCheck className="w-4 h-4 text-electric" strokeWidth={2.5} data-id="element-499" />
                  </div>
                </div>
                <div className="flex-1" data-id="element-500">
                  <div className="text-sm font-bold text-white flex items-center gap-1.5" data-id="element-501">
                    {t.n}
                  </div>
                  <div className="text-xs text-textsecondary flex items-center gap-1" data-id="element-502">
                    <MapPin className="w-3 h-3" data-id="element-503" />
                    {t.l}
                  </div>
                </div>
                {/* Rating */}
                <div className="flex gap-0.5" data-id="element-504">
                  {[...Array(5)].map((_, idx) => <Star key={idx} className="w-3 h-3 text-gold fill-gold" data-id="element-505" />)}
                </div>
              </div>

              {/* Quote */}
              <p className="text-sm text-textsecondary leading-relaxed mb-4 relative z-10" data-id="element-506">
                "{t.t}"
              </p>

              {/* Tag */}
              <div className="pt-3 border-t border-white/5" data-id="element-507">
                <span className="inline-flex items-center gap-1.5 text-[10px] font-bold uppercase tracking-wider text-electric bg-electric/10 px-2.5 py-1 rounded-full" data-id="element-508">
                  <span className="w-1 h-1 rounded-full bg-electric" data-id="element-509"></span>
                  {t.tag}
                </span>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}